module.exports = __webpack_public_path__ + "static/media/icons-yc-ruler.0bf21a84.svg";